import React, { useId } from 'react'
import PropTypes from 'prop-types'

const CheckIcon = React.forwardRef(function CheckIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7071 5.29289C22.0976 5.68342 22.0976 6.31658 21.7071 6.70711L9 19.4142L2.29289 12.7071C1.90237 12.3166 1.90237 11.6834 2.29289 11.2929C2.68342 10.9024 3.31658 10.9024 3.70711 11.2929L9 16.5858L20.2929 5.29289C20.6834 4.90237 21.3166 4.90237 21.7071 5.29289Z"
      ></path>
    </svg>
  )
})

CheckIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CheckIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default CheckIcon
